
<div class="col-12 px-0">
    <div class="d-flex align-items-end flexwrap-items align-items-center">
      <h1 class="px-0 w-75">Search Results</h1>
      <div class="search-holder" *ngIf="isStudyStat">
        <span class="search-title">Search</span>
        <kendo-textbox [(ngModel)]="searchText" [maxlength]=128 (keydown.enter)="onSearch($event)">
            <ng-template kendoTextBoxPrefixTemplate>
                    <img
                      src="{{ cdnEndPoint }}/triport/icons/community/search.svg"
                      alt="Search"
                      style="height: 75%"
                      (click)="onSearch($event)"
                    />
            </ng-template>
            <input kendoTextBox type="text">
        </kendo-textbox>
      </div>
    </div>
<div class="row">
  <div class="" *ngIf="searchResult.length > 0">
    <div *ngFor="let result of searchResult; let i = index">
      <div class="contentbox mr">
        <div class="row">
          <div class="col-3 br">
            <b>
              <div *ngIf="SiteID == 0">
                <span>{{result.PageName }}</span>
              </div>
              <div>
                <a href="{{result.WebPage}}" *ngIf="!isStudyStat">{{result.PageName}}</a>
                
                <a href="/Go/{{sponsor}}/{{portal}}/StudyStat/StudyResources?pid={{result.AssetCategoryId}}" *ngIf="isStudyStat && result.ParentCategoryId == 0">{{result.CategoryName}}</a>
                <div *ngIf="isStudyStat && result.ParentCategoryId! > 0">
                    <a href="/Go/{{sponsor}}/{{portal}}/StudyStat/StudyResources?pid={{result.ParentCategoryId!}}">{{result.ParentCategoryName}}</a> / 
                    <a href="/Go/{{sponsor}}/{{portal}}/StudyStat/StudyResources?pid={{result.ParentCategoryId!}}&cid={{result.AssetCategoryId}}">{{result.CategoryName}}</a>
                </div>

                <div *ngIf="result.PageName == 'FAQs'">
                  <a href="{{result.URL}}" class="fn16-style quick-action">{{result.Type}}</a>
                </div>
                <div *ngIf="result.AssetTypeID != null">
                  <div *ngIf="result.PageName == 'Safety Reports'">
                    <a id=result.AssetID href="javascript:void(0);" class="fn16-style quick-action"
                       (click)="OpenSafetyReportDocument(result.Name,result.PersonAssetID,result.AssetID,result.SusarAssetStatusID);">
                      {{result.Name}}
                    </a>
                  </div>
                  <div *ngIf="result.PageName == 'Messages'">
                    <a href="javascript:void(0);" class="fn16-style quick-action"
                       (click)="OpenMessage(result.Name,result.PersonAssetID,result.PersonAssetGuid,result.AssetID)">
                      {{result.Name}}
                    </a>
                  </div>
                  <div *ngIf="result.PageName == 'Team Documents' || result.PageName == 'Study Documents' || result.PageName == 'News letters' || result.PageName == 'Presentations' || result.PageName == 'My Training'
                                    || result.URL.includes('/Documents/TrackedDocument') || result.URL.includes('/Documents/NonTrackedDocument')">

                                    <a href="javascript:void(0);" class="fn16-style quick-action"
                                       routerLink="/{{result.WebPage}}"  [queryParams]="{aid : result.AssetID}"  *ngIf="!isStudyStat" >
                                    {{result.Name}}</a>
                                    
                                    <a href="javascript:void(0);" class="fn16-style quick-action"
                                       (click)="openDocumentViewer(result)"  *ngIf="isStudyStat" >
                                    {{result.Name}}</a>
                  </div>
                  <div *ngIf="result.PageName == 'SiteForms'">
                    {{result.Name}}
                  </div>
                </div>
              </div>
            </b>
          </div>
          <div class="col-8">
            <div *ngIf="result.AssetTypeID != null">
              <div *ngIf="result.PageName == 'FAQs'">
                <div class="row fn14-style">
                  <b>Question </b><span> {{result.Name}}</span>
                </div>
                <div class="row fn14-style">
                  <b>Answer </b>
                  <span [innerHTML]="result.Description | keepHtml"></span>
                </div>
              </div>

              <div>
                <span class="fn14-style"> {{result.Description}} </span>
              </div>
            </div>
            <div *ngIf="result.AssetTypeID == null">
              <a href="{{result.URL}}" class="fn14-style" target="_blank" rel="noreferrer">{{result.Name}}</a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div *ngIf="searchResult.length == 0" class="contentbox size">
    <div class="fn40-style">
      <img src="{{cdnEndPoint}}/triport/icons/no_search_results.svg" class="mCS_img_loaded" />
      <div class="row ml">
        No results found
      </div>
    </div>
  </div>
</div>
